import { Component, OnInit, HostListener, Input, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { BlobServiceClient, BlockBlobUploadOptions, ContainerClient, BlockBlobClient } from '@azure/storage-blob';
import { ToastrService } from 'ngx-toastr';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { MinhaAgenda } from '@app/models/minha-agenda';
import { Instancia, ProcessoResumo } from '@app/models/processo.model';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ProcessoAnexo } from '@app/models/processo-anexo.model';
import { ProcessoMovimentacao, TipoMovimentacao } from '@app/models/processo-movimentacao';
import { ConsultasService } from '@app/services/consultas.service';
import { ProcessoService } from '@app/services/processo.service';
import { UploadFile } from '@app/components/upload-file/upload-file';

@Component({
  selector: 'app-movimentacao-form',
  templateUrl: './movimentacao-form.component.html',
  styleUrls: ['./movimentacao-form.component.scss']
})
export class MovimentacaoFormComponent implements OnInit {
  @Input() arquivosMenores20MB: boolean = true;

  aguardandoSolicitacao = false;
  lstErros: string[] = [];
  lstUsuarios: IdDescricao[];
  lstMeAviseTipo: IdDescricao[];
  lstAtoProcessual: IdDescricao[];
  lstInstancias: Instancia[];

  processoId: number;
  movimentacaoId: number = null;
  tipo: string;
  titulo: string;
  titulo2: string;
  tipoMovimentacao: TipoMovimentacao;
  numeroInstanciaEstaPreenchido: boolean = false;

  processoMovimentacao: ProcessoMovimentacao;

  sMsg = '';

  lstAgenda: MinhaAgenda[];
  agenda: MinhaAgenda = new MinhaAgenda();
  processoResumo: ProcessoResumo;

  @HostListener('document:keydown', ['$event'])
  atalhoGravar(event: KeyboardEvent) {
    if (event.which === 83 && event.ctrlKey) {
      event.preventDefault();
      if (confirm('deseja realmente gravar?')) {
        this.adicionar();
      }
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private consultasService: ConsultasService,
    private toastrService: ToastrService

  ) { }

  ngOnInit() {
    let onInit = true;

    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];

        if (!onInit) {
          this.initialize();
        }
      });

    this.route.params.subscribe(params => {
      this.tipo = params['tipo'];
      switch (this.tipo.toUpperCase()) {
        case 'ADMINISTRATIVA':
          this.titulo = 'Movimentação Administrativa';
          this.tipoMovimentacao = TipoMovimentacao.ADMINISTRATIVA;
          break;
        case 'EXECUCAO-PROVISORIA':
          this.titulo = 'Movimentação Execução Provisória';
          this.tipoMovimentacao = TipoMovimentacao.EXECUCAO_PROVISORIA;
          break;
        case 'JUDICIAL':
          this.titulo = 'Movimentação Judicial';
          this.tipoMovimentacao = TipoMovimentacao.JUDICIAL;
          break;
        default:
          this.router.navigate([`./processos/processo/${this.processoId}`]);
      }

      if (!onInit) {
        this.initialize();
      }

    });

    this.route.params.subscribe(
      (params: any) => {
        this.movimentacaoId = params['movid'];
        this.titulo2 = this.movimentacaoId ? 'Editar Movimentação' : 'Nova Movimentação';
      });


    onInit = false;
    this.initialize();
  }

  DataAtualCorretaFormatoISO(): string {
    let DataAtual = new Date();
    
    if(DataAtual.getHours() >= 21){
      DataAtual.setDate(DataAtual.getDate() - 1);
      let dataCerta = DataAtual.toISOString().split('T')[0];
      return dataCerta;
    }else{
      let dataCerta = DataAtual.toISOString().split('T')[0];
      return dataCerta;
    }
  }

  initialize() {

    this.consultasService.consultar('USUARIO_APELIDO').toPromise().then(data => this.lstUsuarios = data);
    this.consultasService.consultar('MEAVISETIPO').toPromise().then(data => this.lstMeAviseTipo = data);
    this.processoService.ObterInstancias(this.processoId).subscribe(data => this.lstInstancias = data);

    this.processoMovimentacao = new ProcessoMovimentacao();
    this.processoMovimentacao.Data = this.DataAtualCorretaFormatoISO();
    this.processoMovimentacao.ProcessoId = this.processoId;
    this.processoMovimentacao.TipoMovimentacaoId = this.tipoMovimentacao;
    this.processoMovimentacao.NumeroInstancia = '';
    this.processoMovimentacao.MeAvise = [];
    this.processoMovimentacao.Prazo = [];
    this.processoMovimentacao.Documentos = [];
    this.processoMovimentacao.Arquivos = [];

    this.processoService.obterPartesDoProcesso(this.processoId).subscribe((data: string) => {
      const aud = new MinhaAgenda(data);
      aud.UsuarioId = 0;
      this.processoMovimentacao.Audiencia.push(aud);
    });

    if (this.movimentacaoId != null) {
      this.processoService.obterMovimetnacaoPorId(this.tipoMovimentacao, this.movimentacaoId).toPromise()
        .then((data) => {
          this.processoMovimentacao = data;
          this.processoMovimentacao.Data = this.processoMovimentacao.Data.split('T')[0];
        },
          (error) => this.router.navigate([`./processos/processo/${this.processoId}/mov/${this.tipo}`]));
    }
  }

  selectCheckBox(click: 'fixado' | 'resumo' | 'destaque' | 'preenchimentoNumeroInstancia'): void {
    if (click === 'resumo') {
      this.processoMovimentacao.Destaque = false;
    }

    if (click === 'destaque') {
      this.processoMovimentacao.Resumo = false;
    }

    if (click === 'preenchimentoNumeroInstancia'){
      this.numeroInstanciaEstaPreenchido = !this.numeroInstanciaEstaPreenchido;
    }
  }

  onSubmit() {
    if (this.processoMovimentacao.TipoMovimentacaoId == 2 || this.processoMovimentacao.TipoMovimentacaoId == 3){
      if (!this.numeroInstanciaEstaPreenchido && this.processoMovimentacao.NumeroInstancia === ''){
        this.toastrService.error("Numero da instância é obrigatório");
        return;
      }
    }

    if (this.movimentacaoId == null) {
      this.adicionar();
    } else {
      this.atualizar();
    }
  }

  atualizar() {
    this.processoService.gravarMovimentacao(this.processoMovimentacao).toPromise().then(() => {
      this.router.navigate([`./processos/processo/${this.processoId}/mov/${this.tipo}`]);
    },
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
      });
  }

  populaProcessoResumo(event) {
    this.processoResumo = event;
  }

  adicionar() {
    this._tratarAguarde(true);
    var lstAgenda = [];
    this.processoMovimentacao.MeAvise.forEach(meAvise => {
      if (meAvise.Agenda) {
        var agenda = new MinhaAgenda();
        agenda.Descricao = meAvise.Descricao;
        agenda.HoraInicioAgendada = meAvise.HorarioAgenda;
        agenda.UsuarioId = meAvise.UsuarioAtualId;
        agenda.DataAgendada = meAvise.Data;
        agenda.ProcessoId = meAvise.ProcessoMovimentacaoId;
        lstAgenda.push(agenda);
      }
    });
    this.processoMovimentacao.Agenda= lstAgenda;

    this.processoService.gravarMovimentacao(this.processoMovimentacao).subscribe(
      (data) => {
        if (this.processoMovimentacao.Arquivos.length > 0 || this.processoMovimentacao.Documentos.length > 0) {
          let contadorSucesso = 0;
          if (this.processoMovimentacao.Arquivos.length > 0) {
            this.processoMovimentacao.Arquivos.forEach((arquivos, index) => {
              let processoAnexo: ProcessoAnexo = this.AdicionarInformacoesProcessoAnexo(arquivos, data);

              this.AdicionarAnexoDiretamenteNoStorage(processoAnexo, arquivos)
                .then(() => {
                  contadorSucesso++;
                  if (contadorSucesso === this.processoMovimentacao.Arquivos.length) {
                    this.router.navigate([`./processos/processo/${this.processoId}/mov/${this.tipo}`]);
                    this._tratarAguarde(false);
                  }
                })
                .catch((error) => {
                  this.toastrService.error('Erro ao realizar o upload do arquivo.');
                  console.error(error);
                  this._tratarAguarde(false);
                });
            });
          }
        } else {
          this.router.navigate([`./processos/processo/${this.processoId}/mov/${this.tipo}`]);
          this._tratarAguarde(false);
        }
      }
      ,(data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this._tratarAguarde(false);
      }
    );
  }

  private _tratarAguarde(bloquearTela: boolean): void {
    if(bloquearTela) {
      this.aguardandoSolicitacao = bloquearTela;
      document.getElementById('overlay').style.display = 'block';
      return;
    }

    if(!bloquearTela) {
      this.aguardandoSolicitacao = bloquearTela;
      document.getElementById('overlay').style.display = 'none';
      return;
    }
  }

  AdicionarInformacoesProcessoAnexo(fileProcessoAnexo: UploadFile, movimentacaoId: number) {
    let processoAnexo = new ProcessoAnexo();
    let fileNameArray: string[] = fileProcessoAnexo.File.name.split('.');

    processoAnexo.ArquivoNome = fileProcessoAnexo.File.name;
    processoAnexo.Descricao = fileProcessoAnexo.Descricao;
    processoAnexo.Extensao = fileNameArray[fileNameArray.length - 1];


    processoAnexo.MovimentacaoId = movimentacaoId;
    processoAnexo.ProcessoId = this.processoId;
    return processoAnexo;
  }

  AdicionarAnexoDiretamenteNoStorage(processoAnexo: ProcessoAnexo, fileProcessoAnexo: UploadFile): Promise<void> {
    let idAnexoMovimentacao: number = 0;

    return this.processoService.movimentacaoGravarProcessoAnexoRetornandoSas(processoAnexo).pipe(
      switchMap(uploadFileSasUrl => {
        fileProcessoAnexo.progress = 0;

        idAnexoMovimentacao = Number.parseInt(uploadFileSasUrl.NomeArquivo.replace(/([A-z]+)\_(\d+)\.([A-z0-9]+)/, "$2"), 10);

        const blobService = new BlobServiceClient(uploadFileSasUrl.SasUrlUpload);
        const containerClient = blobService.getContainerClient('');
        const blobClient = containerClient.getBlockBlobClient(uploadFileSasUrl.NomeArquivo);

        fileProcessoAnexo.progress = 10;

        const optionsBlobClient: BlockBlobUploadOptions = {
          onProgress: (ev) => {
            fileProcessoAnexo.progress = Math.round((ev.loadedBytes / fileProcessoAnexo.File.size) * 80) + 10;
          },
          blobHTTPHeaders: { blobContentType: fileProcessoAnexo.File.type }
        };

        // Verificação para arquivos maiores que 1 GB
        if (fileProcessoAnexo.File.size > 1024 * 1024 * 1024) { // Arquivos maiores que 1 GB
          return from(this.uploadInChunks(blobClient, fileProcessoAnexo.File, optionsBlobClient));
        } else {
          return from(blobClient.upload(fileProcessoAnexo.File, fileProcessoAnexo.File.size, optionsBlobClient));
        }
      })
    ).pipe(
      switchMap(() => {
        return this.processoService.verificaExistenciaArquivoMovimentacao(idAnexoMovimentacao, "proanexo").toPromise().then(existenciaArquivo => {
          if (existenciaArquivo) {
            fileProcessoAnexo.progress = 100;
          } else {
            this.processoService.movimentacaoDeletarArquivo(idAnexoMovimentacao);
          }
        }).catch(error => {
          this.processoService.movimentacaoDeletarArquivo(idAnexoMovimentacao);
          this.lstErros.push("Não foi possível realizar o upload!");
          this._tratarAguarde(false);
        });
      })
    ).toPromise();
  }

  // Método auxiliar para upload em blocos
  private async uploadInChunks(blobClient: BlockBlobClient, file: File, options: BlockBlobUploadOptions): Promise<void> {
    const chunkSize = 4 * 1024 * 1024; // 4 MB por bloco
    const fileSize = file.size;
    let offset = 0;

    while (offset < fileSize) {
      const chunk = file.slice(offset, offset + chunkSize);
      await blobClient.stageBlock(
        this.generateBlockId(offset),
        chunk,
        chunk.size,
        options
      );
      offset += chunkSize;
    }

    // Commit dos blocos
    const blockList = Array.from({ length: Math.ceil(fileSize / chunkSize) }, (_, i) =>
      this.generateBlockId(i * chunkSize)
    );
    await blobClient.commitBlockList(blockList, options);
  }

  // Gera um ID único para cada bloco
  private generateBlockId(offset: number): string {
    return btoa(`block-${offset}`);
  }
}
